import type { ReactNode } from "react";
import { Chip } from "@mui/material";
import type CommandeArticleCartModel from "models/CommandeArticleCartModel";
import { useSelector } from "react-redux";
import type { StoreProps } from "store/store";

type CartChipProps = {
  color?: "primary" | "default" | "secondary" | "error" | "info" | "success" | "warning";
  size?: "small" | "medium";
};

function CartChip({ color = "primary", size = "small" }: Readonly<CartChipProps>): ReactNode {
  const cart = useSelector<StoreProps, Array<CommandeArticleCartModel>>((state) => state?.cart);

  if (cart.length === 0) return null;

  return <Chip size={size} label={cart.length} color={color} />;
}

export default CartChip;
